'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _util = require('./util.service');

var _util2 = _interopRequireDefault(_util);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var utilModule = _angular2.default.module('util.service', []).service('Util', _util2.default).name;

exports.default = utilModule;


// WEBPACK FOOTER //
// ./client/app/services/utilService/util.js